





































































import ReconnectingWebSocket from "reconnecting-websocket";

//import lodash from "lodash";
import axios from "axios";
//import uuid from "uuid/v4";
import { Route } from "vue-router";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  DimssaButton,
  ButtonState
} from "@/components/shared/dimssa-button.vue";
import DimssaTable from "@/components/shared/dimssa-table.vue";
import Tag from "@/models/count/tag";
import RollCall from "@/models/count/roll-call";
import { formatDateToSqlDateTime } from "@/helpers/date-time";
import { restApi } from "@/rest-api";
import { dissectSgtin } from "@/helpers/dissect-sgtin";
import AppSettings from "../../app-settings";
import { AppState } from "@/store/modules/count";
//import { Tag, RollCall } from "../data-manager"
import lodash from "lodash";

@Component({
  components: { DimssaButton, DimssaTable }
})
export default class Scan extends Vue {
  numRecentTags: number = 10;
  get recentTags(): Tag[] {
    return this.$store.state.countModule.tags
      .slice(-this.numRecentTags)
      .reverse();
  }

  getTagString(tag: Tag, index: number) {
    let i = this.$store.state.countModule.tags.length - index;
    return `${i}  - ${dissectSgtin(tag.SGTIN)}`;
  }

  get tagTextStyle(): string {
    let appState: AppState = this.$store.state.countModule.appState;
    let numTags: number = this.$store.state.countModule.tags.length;
    if (
      numTags > 0 &&
      (appState === "connecting" ||
        appState === "stopping_before_counting" ||
        appState === "connected" ||
        appState === "stopped_before_counting")
    ) {
      return "color: red";
    }
    return "";
  }

  get countButtonText(): string {
    let appState: AppState = this.$store.state.countModule.appState;
    if (
      appState === "stopped_before_counting" ||
      appState === "stopping_before_counting"
    ) {
      return "Check";
    } else if (appState === "menu") {
      return "Connect";
    } else {
      return "Count";
    }
    //return  === "stopped_before_counting" ? "Check" : "Count"
  }

  resetButtonVisible: boolean = false;

  //scanStatusMessage: string = "Ready";
  get scanStatusMessage(): string {
    let isError: boolean = this.$store.state.countModule.error;
    switch (this.$store.state.countModule.appState) {
      case "menu": {
        return "Press Connect to begin";
      }
      case "connecting": {
        return isError ? "Error connecting" : "Connecting...";
      }
      case "connected": {
        return "Connected and checking for tags...";
      }
      case "stopping_before_counting": {
        return isError ? "Error stopping scan" : "Stopping scan...";
      }
      case "stopped_before_counting": {
        return "Scanning stopped before counting was started";
      }
      case "counting": {
        return "Counting tags";
      }
      case "stopping_counting": {
        return isError ? "Error stopping counting" : "Stopping counting";
      }
      case "stopped_counting": {
        return "Counting stopped";
      }
      case "resuming_counting": {
        return isError ? "Error resuming counting" : "Resuming counting";
      }
      case "saving": {
        return isError ? "Error saving" : "Saving";
      }
      case "saved": {
        return "Saved";
      }
    }
  }

  //countButtonState_: ButtonState = "ready";
  stopButtonState_: ButtonState = "ready";
  saveButtonState_: ButtonState = "ready";
  //clearButtonState_: ButtonState = "ready";

  get countButtonState(): ButtonState {
    let appState: AppState = this.$store.state.countModule.appState;
    let error: boolean = this.$store.state.countModule.error;
    if (appState === "menu") {
      return "ready";
    } else if (appState === "counting") {
      return "success";
      //return "disabled";
    } else if (
      this.$store.state.countModule.countButtonBackoff ||
      (appState === "connected" &&
        this.$store.state.countModule.tags.length > 0)
    ) {
      return "disabled";
    } else if (
      !error &&
      (appState === "connecting" || appState === "resuming_counting")
    ) {
      return "busy";
    } else if (
      error &&
      (appState === "connecting" || appState === "resuming_counting")
    ) {
      return "error";
    } else if (appState === "saving" || appState === "saved") {
      return "disabled";
    } else {
      return "ready";
    }
    //return this.countButtonState_;
  }

  get stopButtonState(): ButtonState {
    let appState: AppState = this.$store.state.countModule.appState;
    let error: boolean = this.$store.state.countModule.error;
    if (appState === "menu") {
      return "disabled";
    } else if (
      appState === "stopping_before_counting" ||
      appState === "stopping_counting"
    ) {
      if (error) {
        return "error";
      } else {
        return "busy";
      }
    } else if (
      appState === "connecting" ||
      appState === "stopped_before_counting" ||
      appState === "stopped_counting"
    ) {
      //return "success";
      return "disabled";
    } else if (appState === "saving" || appState === "saved") {
      return "disabled";
    }
    return this.stopButtonState_;
  }

  get saveButtonState(): ButtonState {
    let appState: AppState = this.$store.state.countModule.appState;
    let isError: boolean = this.$store.state.countModule.error;
    if (this.$store.state.countModule.tags.length == 0) {
      return "disabled";
    } else if (appState === "saving" && !isError) {
      return "busy";
    } else if (appState === "saving" && isError) {
      return "error";
    } else if (appState === "saved") {
      return "success";
    } else if (
      appState === "counting" ||
      appState === "stopping_counting" ||
      appState === "stopped_counting" ||
      appState === "resuming_counting"
    ) {
      return "ready";
    } else {
      return "disabled";
    }
    //return this.saveButtonState_;
  }

  get clearButtonState(): ButtonState {
    if (this.$store.state.countModule.tags.length > 0) {
      return "ready";
    } else {
      return "disabled";
    }
  }

  // statusBarMessage(message: string) {
  //   this.$store.commit("statusBarModule/SET_MESSAGE", message);
  // }

  onCount() {
    let appState: AppState = this.$store.state.countModule.appState;
    let error: boolean = this.$store.state.countModule.error;
    if (appState === "menu" || (appState == "connecting" && error)) {
      this.$store.dispatch("countModule/connect");
    } else if (appState == "resuming_counting" && error) {
      this.$store.dispatch("countModule/connect", { jumpToCountingState: true });
    } else if (appState !== "counting") {
      this.$store.dispatch("countModule/startCount");
    }
  }

  onStop() {
    this.$store.dispatch("countModule/stopCount");
  }

  countButtonBackoffDebounced: any = null;

  onClear() {
    let appState: AppState = this.$store.state.countModule.appState;
    if (
      appState === "connected" ||
      appState === "stopped_before_counting" ||
      appState === "stopping_before_counting" ||
      appState === "connecting"
    ) {
      if (appState !== "stopped_before_counting") {
        if (this.countButtonBackoffDebounced) {
          this.countButtonBackoffDebounced.cancel();
        }
        //wait 5 seconds before enabling count button, if stopped then Check button will show in place of Count, that can enable immediately
        this.$store.commit("countModule/SET_COUNT_BUTTON_BACKOFF", true);
        this.countButtonBackoffDebounced = lodash.debounce(() => {
          this.$store.commit("countModule/SET_COUNT_BUTTON_BACKOFF", false);
        }, 5000);
        this.countButtonBackoffDebounced();
      }
      this.$store.commit("countModule/CLEAR_TAGS");
    } else if (
      appState === "counting" ||
      appState === "stopped_counting" ||
      appState === "stopping_counting" ||
      appState === "resuming_counting"
    ) {
      this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
        key: "mode",
        value: "yesNo"
      });
      this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
        key: "yesAction",
        value: () => {
          this.$store.commit("countModule/CLEAR_TAGS");
          this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
            key: "popupVisible",
            value: false
          });
        }
      });
      this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
        key: "popupMessage",
        value: "Are you sure you want to clear?"
      });
      this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
        key: "popupVisible",
        value: true
      });
    } else if (this.$store.state.countModule.appState === "saved") {
      this.$store.commit("countModule/CLEAR_TAGS");
      this.$store.commit("countModule/SET_APP_STATE", "menu");
      // lodash.debounce(() => {
      //   this.$router.push({ path: "count-menu" });
      // }, 1000)();
    } else if (appState === "saving" && this.$store.state.countModule.error) {
      this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
        key: "mode",
        value: "yesNo"
      });
      this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
        key: "yesAction",
        value: () => {
          this.$store.commit("countModule/CLEAR_TAGS");
          this.$store.commit("countModule/SET_APP_STATE", "menu");
          // lodash.debounce(() => {
          //   this.$router.push({ path: "count-menu" });
          // }, 1000)();
          this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
            key: "popupVisible",
            value: false
          });
        }
      });
      this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
        key: "popupMessage",
        value: "Are you sure you want to clear?"
      });
      this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
        key: "popupVisible",
        value: true
      });
    }
  }

  onSave() {
    if (this.$store.state.countModule.appState === "saved") {
      return;
    }

    if (
      this.$store.state.countModule.appState === "saving" &&
      this.$store.state.countModule.error
    ) {
      this.$store.dispatch("countModule/saveResults");
    } else {
      this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
        key: "mode",
        value: "yesNo"
      });
      this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
        key: "yesAction",
        value: () => {
          this.$store.dispatch("countModule/saveResults");
          this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
            key: "popupVisible",
            value: false
          });
        }
      });
      this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
        key: "popupMessage",
        value: "Are you sure you want to save?"
      });
      this.$store.commit("popupDialogModule/MUTATE_POPUP_DIALOG_STATE", {
        key: "popupVisible",
        value: true
      });
    }
  }

  mounted() {
    console.log("mounted");
    // let appState: AppState = this.$store.state.countModule.appState;
    // if (appState === "menu") {
    //   this.$router.push({ path: "count-menu" });
    // }
  }

  destroyed() {}

  @Watch("$store.state.countModule.appState")
  onAppStateChanged(newState: any, oldState: any) {
    //console.log(`newState: ${newState}, oldState: ${oldState}`);
    console.log(`${oldState} => ${newState}`);
  }

  @Watch("$store.state.countModule.webSocket.readyState")
  onWebSocketChanged(newState: any, oldState: any) {
    console.log(`newReadyState: ${newState}, oldReadyState: ${oldState}`);
  }
}
